import React from 'react';

class MenuSelectionCard extends React.Component {
  render() {
    const {
      dish = {},
      menu_selection,
      className = 'menu-selection-card',
      activeClassName = 'menu-selection-card--active'
    } = this.props;
    const isActive = menu_selection.quantity > 0;
    const classNames = [className];
    if (isActive) classNames.push(activeClassName);

    return (
      <div className={classNames.join(' ')} onClick={this.toggle}>
        <div className="menu-selection-card__name">{dish.name}</div>
        <div className="menu-selection-card__diet">
          {dish.dietary_preference_tags
            .map(tag => tag.abbreviation)
            .join(' | ')}
        </div>
        <div className="menu-selection-card__count">
          {menu_selection.quantity > 1 ? `x${menu_selection.quantity}` : ''}
        </div>

        <div
          className="menu-selection-card__link a--blue"
          onClick={this.popModal}
        >
          Customize Dish
        </div>
      </div>
    );
  }

  toggle = e => {
    const { quantity = 0 } = this.props.menu_selection;
    if (quantity > 1) {
      this.props.openModal(this.props.index);
      return; // pop modal
    }

    const menu_selection = {
      ...this.props.menu_selection,
      quantity: quantity === 0 ? 1 : 0,
      notes: ''
    };
    this.props.updateMenuSelection(this.props.index, menu_selection);
  };

  popModal = e => {
    e.stopPropagation();
    this.props.openModal(this.props.index);
  };
}

export default MenuSelectionCard;



// WEBPACK FOOTER //
// ./src/components/shared/MenuSelectionCard.js